
import React, { useState } from 'react';
import {
  useQueryClient,
  useMutation,
  useQuery,
} from '@tanstack/react-query';
import Loading from '../Loading';
import { Link, useNavigate } from 'react-router-dom'
import { Input, InputDropdown, Button } from '../myComponents/MyComponents';
import { getGrades, getStudentByCls, getStudentByGradeAndName, getStudentByNid } from '../myComponents/StudentsApi';

const Quiz = () => {
  const navigate = useNavigate();
  const participant = JSON?.parse(localStorage?.getItem("student")) || {};
  const [student, setStudent] = useState('');
  const [students, setStudents] = useState([]);
  const [err, setErr] = useState('')
  const [inputs, setInputs] = useState({})
  const [errors, setErrors] = useState({})
  const [showQtns, setShowQtns] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState({});

  const { isPending, error, data: grades } = useQuery({
    queryKey: ['grades'],
    queryFn: async () => {
      try {
        //const datas = await axios.get(authapi);
        const datas = getGrades();
        //console.log(datas)
        return datas;
        //return datas?.data;
      } catch (error) {
        console.error('Error fetching grades:', error);
        throw error;
      }
    },
  });

  const { mutate: getStudents, isPending: gettingStudents } = useMutation({
    mutationKey: ['students'],
    mutationFn: async (selectedGrade) => getStudentByCls(selectedGrade),
    onSuccess: (data) => {
      setStudents(data);
      // queryClient.invalidateQueries(['grades']);
    },
    onError: (error) => {
      console.error('Error fetching students:', error);
    },
  });


  const handleFindByNid = async (e) => {
    setErrors({});
    setLoading(true)
    const gofi = inputs?.gofi;
    let res = getStudentByNid(inputs?.nid)
    if (!!res.nid) {
      let data = res;
      setStudent(data?.name_en)
      localStorage.setItem('student', JSON.stringify(data));
      localStorage.setItem('gofi', inputs?.gofi || data?.gofi);
      localStorage.setItem('isbalaigen', gofi);
      localStorage.setItem('grade', data?.grade);
      setShowQtns(true);
      setSuccess({ successGettingByNid: `Student: ${data?.name_en}` });
      setLoading(false)
      navigate('/questions');
    }
    else {
      setErrors({ wrongNid: "no student with given nid found" });
      setLoading(false)
      return ("no student with given nid found");
    }
  };


  const handleFindQuestions = async (e) => {
    setLoading(true)
      const gofi = inputs?.gofi;
      const grade = inputs?.grade;
      localStorage.setItem('gofi', gofi);
      localStorage.setItem('grade', grade);
      setShowQtns(true);
      setLoading(false)
      navigate('/questions');

  };


  const handleChangeGrade = (e) => {
    console.log(e.target.value);
    setInputs({ ...inputs, [e.target.id]: e.target.value });
    getStudents(e.target.value);
  };

  const handleChange = (e) => {
    setInputs({ ...inputs, [e.target.id]: e.target.value });
  };


  if (isPending) return <Loading />;

  return (<>
    <div className=''>
      {/* {JSON.stringify(participant)} */}
      <div className='bg-purple-200 rounded-xl m-2'>
        <div className='flex justify-center gap-1 p-2'>
          <div className="max-w-md w-1/3 mx-auto bg-purple-900 rounded-md shadow-md">

            <div className='p-1'>
              <InputDropdown label="Grade" data={inputs} errors={errors}
                onChange={handleChangeGrade} type="text" id="grade"
                obj={[
                  {id:1, body:1},
                  {id:2, body:2},
                  {id:3, body:3},
                  {id:4, body:4},
                  {id:5, body:5},
                  {id:6, body:6},
                  {id:7, body:7},
                  {id:8, body:8},
                  {id:9, body:9},
                  {id:10, body:10}
                ]}
              />
              <div className="mb-4">
                <label htmlFor="gofi" className="block text-gray-100 text-sm font-bold mb-2">
                Gofi
                </label>
                <select
                  id="gofi"
                  name="gofi"
                  className="w-full p-2 border rounded text-black"
                  value={inputs["gofi"]}
                  onChange={handleChange}
                >
                  <option value="choose">Select gofi</option>
                   <option value="balaigen">Balaigen</option>
                   <option value="nubalai">nubalai</option>
                </select>
              </div>

              {error && <p className="text-red-500 mb-4">{errors}</p>}
              <Button label="Get Questions" onClick={handleFindQuestions} />

              <span className='text-red-700 ml-5'>{err && err}</span>
              {loading && <div className='text-center m-2'><Loading /></div>}
            </div>
          </div>


        </div>


      </div>

    </div>

  </>
  );
};

export default Quiz;
